import { Text } from '@manychat/mudra'

export const texts = []

export default class ManagedText extends Text {
  constructor() {
    super()
    this.resolution = 0.125
    texts.push(this)
  }

  destroy() {
    const index = texts.indexOf(this)
    if (index >= 0) {
      texts.splice(index, 1)
    }
    super.destroy()
  }
}
